/// <reference types="urijs" />
/// <reference types="jquery" />

// queryString parameter name
const paramName = "appSecCoachUrl";
// whitelist for expected routing domains
const domainsWhitelist = [
    /^.*\.checkmarx\.net$/, 
    /^.*\.checkmarx\.com$/, 
    /^34\.248\.215\.24$/,
    /^localhost$/, 
    /^127\.0\.0\.1$/,
    /^10\.\d+\.\d+\.\d+$/,
    /^192\.168\.\d+\.\d+$/,
    /^ec2-34-248-215-24.eu-west-1.compute.amazonaws.com$/
];


interface HTMLIFrameElement {
    srcdoc: string | undefined // This property is not available in IE
}

const iFrameUrl = getParameterByName(paramName) || localStorage.getItem("iFrameUrl")


if (iFrameUrl === null || !validateUrlExpectedDomains(iFrameUrl)) { 
    const iFrame = createIframeElement();
    iFrame.src = "404.html"
} else {
    const cachedLessonUrl = localStorage.getItem(iFrameUrl)
    if (cachedLessonUrl) {
        const iFrame = createIframeElement();
        iFrame.src = cachedLessonUrl
    } else {
        const iFrameUrlComps = URI(iFrameUrl)
        if (iFrameUrlComps.hasQuery("signedIdentity")) {
            prefetchCxAuthCall(iFrameUrl)
            .then(function(pr){
                if (pr.success) {
                    localStorage.setItem(iFrameUrl,pr.codeBashingUrl!)
                }

                const iFrame = createIframeElement();

                if (iFrame.srcdoc != undefined) {
                    iFrame.srcdoc = pr.originalBody
                } else {
                    iFrame.src = iFrameUrl
                }
            })
        } else {
            const iFrame = createIframeElement();
            iFrame.src = iFrameUrl
        }
        
    }
    localStorage.setItem("iFrameUrl",iFrameUrl)
}


const urlComponents = URI(window.location.href)
history.replaceState({},"",urlComponents.origin() + urlComponents.path())


/* -------- FUNCTIONS --------*/


/* -- get parameter value from query string, if not exist returns null -- */
function getParameterByName(name: string) {
    const parsedQuery = URI.parseQuery(URI(window.location.href).query())
    return parsedQuery[name];
}



/* -- add iframe element to the document -- */
function createIframeElement() {
    const iframeStyleAttribute = "width: 100%; height: 100%; position: fixed; border: none;";
    var element = document.createElement("iframe");
    element.setAttribute("style", iframeStyleAttribute);
    document.body.appendChild(element);
    return element
}


/* -- Validate that one of the expected domains from the whitelist exists in the url --*/
function validateUrlExpectedDomains(url: string) {
    const domain = URI(url).hostname() 
    for (let regex of domainsWhitelist) {
        if (regex.test(domain)) {
            return true
        }
    }
    console.error('The domain specified in the argument is not whitelisted: ' + domain);
    return false;
}


interface IAuthResponse {
    success: boolean,
    codeBashingUrl: string | null,
    originalBody: string
}

/**
 * Sends a get request to CxAuthServer and parses the result
 * 
 */

function prefetchCxAuthCall(url: string) : Promise<IAuthResponse> {
    const result = new Promise<IAuthResponse>(function(resolve, reject){
        $.get(url).then(function(body){
            resolve({
                success: true,
                codeBashingUrl: findCodeBashingUrl(body),
                originalBody: body
            })
        })
        .fail(function(xhr){
            resolve({
                success: false,
                codeBashingUrl: null,
                originalBody: xhr.responseText
            })
        })
    })
    return result;
}

function findCodeBashingUrl(body: string): string {
    const re1 = /<form\s+method="post"\s+action="([^"]*)"/
    const firstPart = re1.exec(body)
    if (!firstPart || firstPart.length != 2) {
        throw new Error("Couldn't find post url in CxAuthServer response")
    }
    const postUrl = firstPart[1]
    
    const re2 = /<input\s+type="hidden"\s+name="lesson"\s+value="([^"]*)"/
    const secondPart = re2.exec(body)
    if (!secondPart || secondPart.length != 2) {
        throw new Error("Couldn't find lesson url in CxAuthServer response")
    }
    const lessonUrl = secondPart[1]

    return URI(postUrl).pathname(lessonUrl).toString()
}